import { render, staticRenderFns } from "./DialogReviewJournal.vue?vue&type=template&id=727bda3a"
import script from "./DialogReviewJournal.vue?vue&type=script&lang=js"
export * from "./DialogReviewJournal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports